(function($) {
    $(document).ready(function() {
        
        if (typeof citiesAndZips !== 'undefined') {
            
            let locations = Array();
            const locationField = $('.as-search-form #location');
            
            locationField.autocomplete({
                
                source: citiesAndZips,
                
                select: function(event, ui) {
                    
                    $('.as-search-form .error').remove();
                    
                    locations.push(ui.item.value);
                    $('.selected-locations').append('<li class="chosen-location ' + ui.item.value + '"><span class="location-text">' + ui.item.label + '</span><i class="fa fa-times" id="' + ui.item.value + '"></i></li>');
                    
                    if (ui.item.hasOwnProperty('isCity')) {
                        $('<input>').attr({
                            type: 'hidden',
                            id: ui.item.value,
                            name: 'cityId[]',
                            value: ui.item.value
                        }).prependTo('.as-search-form');
                    } else {
                        /**
                         * Determine if is zip (USA) or postal code (CAD) and search accordingly
                         */
                        let firstChar = ui.item.value.split("")[0];
                        console.log(isNaN(firstChar));
                        if (isNaN(firstChar)) {
                            $('<input>').attr({
                                type: 'hidden',
                                id: ui.item.label.replace(/\s/g, ''),
                                name: 'mapCode[]',
                                value: ui.item.value
                            }).prependTo('.as-search-form');
                        } else {
                            $('<input>').attr({
                                type: 'hidden',
                                id: ui.item.label.replace(/\s/g, ''),
                                name: 'zip[]',
                                value: ui.item.value
                            }).prependTo('.as-search-form');
                        }
                    }
                    
                    // clears input after it has been added
                    $(this).val('');
                    return false;
                }
            });
        }
        
        $(document).on('click', '.selected-locations .chosen-location .fa.fa-times', function(e) {
            e.preventDefault();
            let cityId = $(this).attr('id');
            $('.selected-locations .' + cityId).remove();
            $('input[type="hidden"]#' + cityId).remove();
        });
        
        $('#as-location-submit').on('click', function(e) {
            e.preventDefault();
            if ($('.as-search-form input[type="hidden"]').length) {
                $('.as-search-form').submit();
            } else {
                $('.location-container').append('<p class="error" style="' +
                    'position: absolute; ' +
                    'color: red; ' +
                    'font-weight: bold; ' +
                    'bottom: -44px;' +
                    'margin: 0;">Matching area is required.</p>');
                return false;
            }
        });
    });
    
})(jQuery, this);
